export default "__VITE_ASSET__BcjLdQpP__"